module.exports = __webpack_public_path__ + "img/products-2.0e526730.jpg";